import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { Smartico } from '../../core/Smartico'
import { RootState } from '../store'
import { TMiniGameTemplate } from '@smartico/public-api/dist/WSAPI/WSAPITypes'

interface MinigameListState {
    minigames: TMiniGameTemplate[]
    error: string | null
}

const initialMinigameListState: MinigameListState = {
    minigames: [],
    error: null,
}

// Thunk to fetch the list of minigames
export const fetchMinigamesList = createAsyncThunk('minigames/fetchMinigamesList', async (_, { rejectWithValue }) => {
    try {
        const smarticoApi = await Smartico.apiReady
        const minigames = await smarticoApi.getMiniGames()
        return minigames
    } catch (error) {
        return rejectWithValue('Failed to fetch minigames list')
    }
})

// Action to subscribe to minigames updates
export const subscribeToMinigamesUpdates = () => async (dispatch: any) => {
    try {
        const smarticoApi = await Smartico.apiReady
        await smarticoApi.getMiniGames({
            onUpdate: (updatedMinigames: TMiniGameTemplate[]) => {
                if (updatedMinigames && updatedMinigames.length > 0) {
                    dispatch(updateMinigames(updatedMinigames))
                }
            },
        })
    } catch (error) {
        console.error('Error subscribing to minigames updates:', error)
    }
}

// Slice for managing minigames list state
const minigameListSlice = createSlice({
    name: 'minigames',
    initialState: initialMinigameListState,
    reducers: {
        updateMinigames(state, action) {
            state.minigames = action.payload
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchMinigamesList.pending, (state) => {
                state.minigames = []
                state.error = null
            })
            .addCase(fetchMinigamesList.fulfilled, (state, action) => {
                state.minigames = action.payload
                state.error = null
            })
            .addCase(fetchMinigamesList.rejected, (state, action) => {
                state.minigames = []
                state.error = action.payload as string
            })
    },
})

// Exporting the actions and selectors
export const { updateMinigames } = minigameListSlice.actions
export const selectAllMinigames = (state: RootState) => state.minigames.minigames
export default minigameListSlice.reducer